import messages from './cmsScheduleRowMarker.json' with { type: 'json' };

export const cmsScheduleRowMarkerEn: Readonly<typeof messages> = messages;
